export const formateTime = (time) => {
	const seconds = formatTimeS(time % 60);
	const minutes = formatTimeS(Math.trunc((time / 60) % 60));
	const hour = formatTimeS(Math.trunc((time / 60 / 60) % 60));
	return `${hour}:${minutes}:${seconds}`;
};

const formatTimeS = (time) => (time > 9 ? time : `0${time}`);
